import { createAction, props } from '@ngrx/store'

export const fetchMatchMetricFinderMetrics = createAction(
  '[MetricFinder] fetch match metrics',
  props<{ matchId?: string }>()
)
